import React from 'react';

const Footer = () => {
  return (
    <div style={styles.footer}>
      <div style={styles.topLine}></div> 
      <div style={styles.footerWrapper}>
        <div style={styles.bottomSection}>
          <div style={styles.infoColumn}>
            <h4 style={styles.heading}>O Nama</h4>
            <p style={styles.item}>Naš tim</p>
            <p style={styles.item}>Kako smo počeli</p>
            <p style={styles.item}>Lokacije</p>
            <p style={styles.item}>Kontakt</p>
          </div>
          <div style={styles.infoColumn}>
            <h4 style={styles.heading}>Funkcionalnosti</h4>
            <p style={styles.item}>Kreiranje zahteva</p>
            <p style={styles.item}>Pregled ponuda</p>
            <p style={styles.item}>Admin panel</p>
            <p style={styles.item}>Ocene prodavaca</p>
          </div>
          <div style={styles.infoColumn}>
            <h4 style={styles.heading}>Podrška</h4>
            <p style={styles.item}>Vodič za korisnike</p>
            <p style={styles.item}>Česta pitanja</p>
            <p style={styles.item}>Saveti za kupce</p>
            <p style={styles.item}>Podrška uživo</p>
          </div>
          <div style={styles.infoColumn}>
            <h4 style={styles.heading}>Pravne smernice</h4>
            <p style={styles.item}>Uslovi korišćenja</p>
            <p style={styles.item}>Politika privatnosti</p>
            <p style={styles.item}>Prava korisnika</p>
            <p style={styles.item}>Odricanje odgovornosti</p>
          </div>
        </div>
      </div>
      <div style={styles.bottomLine}></div> 
      <div style={styles.copyright}>
        <p>Copyright (c) 2025. SmartPart d.o.o • Sva prava zadržana</p>
      </div>
    </div>
  );
};

export default Footer;

const styles = {
  footer: {
    backgroundColor: '#404040',
    fontFamily: 'sans-serif',
  },
  topLine: {
    height: 1,
    backgroundColor: '#D3E205',
  },
  bottomLine: {
    height: 1,
    backgroundColor: '#171718',
  },
  footerWrapper: {
    padding: '30px 30px',
  },
  bottomSection: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  infoColumn: {
    flex: '1 1 180px',
    marginBottom: 20,
  },
  heading: {
    color: '#D3E205',
    fontSize: '24px',
    marginBottom: 10,
  },
  item: {
    color: '#ffffff',
    fontSize: '20px',
    marginBottom: 6,
  },
  copyright: {
    padding: '10px 0',
    textAlign: 'center',
    color: '#ffffff',
    fontSize: '16px',
    lineHeight: '24px',
    LineWeight:400,
  },
};
